<template>
  <small-subheader>
    <span class="title font-weight-medium">Privacy Policy</span>
  </small-subheader>
</template>

<script>
import SmallSubheader from '@/components/layout/SmallSubheader'

export default {
  components: { SmallSubheader }
}
</script>
